import { render, staticRenderFns } from "./SpoiledLocations.vue?vue&type=template&id=27c40d02&scoped=true&"
import script from "./SpoiledLocations.vue?vue&type=script&lang=js&"
export * from "./SpoiledLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c40d02",
  null
  
)

export default component.exports